export const GET_SERVICE_TYPES = 'accountSettingsPage/GET_SERVICE_TYPES'
export const GET_SERVICE_TYPES_SUCCESS = 'accountSettingsPage/GET_SERVICE_TYPES_SUCCESS'
export const GET_SERVICE_TYPES_ERROR = 'accountSettingsPage/GET_SERVICE_TYPES_ERROR'

export const EDIT_PROVIDER_PROFILE_INFO = 'accountSettingsPage/EDIT_PROVIDER_PROFILE_INFO'
export const EDIT_PROVIDER_PROFILE_IMAGE = 'accountSettingsPage/EDIT_PROVIDER_PROFILE_IMAGE'
export const EDIT_PROVIDER_PROFILE_INFO_SUCCESS = 'accountSettingsPage/EDIT_PROVIDER_PROFILE_INFO_SUCCESS'

export const EDIT_PROVIDER_PROFILE_IMAGE_SUCCESS = 'accountSettingsPage/EDIT_PROVIDER_PROFILE_IMAGE_SUCCESS'
export const EDIT_PROVIDER_PROFILE_IMAGE_ERROR = 'accountSettingsPage/EDIT_PROVIDER_PROFILE_IMAGE_ERROR'
export const EDIT_PROVIDER_PROFILE_INFO_ERROR = 'accountSettingsPage/EDIT_PROVIDER_PROFILE_INFO_ERROR'

export const EDIT_PROVIDER_PASSWORD = 'accountSettingsPage/EDIT_PROVIDER_PASSWORD'
export const EDIT_PROVIDER_PASSWORD_SUCCESS = 'accountSettingsPage/EDIT_PROVIDER_PASSWORD_SUCCESS'
export const EDIT_PROVIDER_PASSWORD_ERROR = 'accountSettingsPage/EDIT_PROVIDER_PASSWORD_ERROR'

export const EDIT_PREFERENCES_SETTINGS = 'accountSettingsPage/EDIT_PREFERENCES_SETTINGS'
export const EDIT_PREFERENCES_SETTINGS_SUCCESS = 'accountSettingsPage/EDIT_PREFERENCES_SETTINGS_SUCCESS'
export const EDIT_PREFERENCES_SETTINGS_ERROR = 'accountSettingsPage/EDIT_PREFERENCES_SETTINGS_ERROR'

export const SET_PASSWORD_ERROR_MESSAGE = 'accountSettingsPage/SET_PASSWORD_ERROR_MESSAGE'
export const SET_IS_EDIT_SUCCESS = 'accountSettingsPage/SET_IS_EDIT_SUCCESS'
export const SET_IS_IMG_UPLOADED_SUCCESS = 'accountSettingsPage/SET_IS_IMG_UPLOADED_SUCCESS'
export const SET_TABS = 'accountSettingsPage/SET_TABS'
export const SET_ERROR = 'accountSettingsPage/SET_ERROR'
export const CLEAR_PHONE_ERROR = 'accountSettingsPage/CLEAR_PHONE_ERROR'
export const SET_LOADING = 'accountSettingsPage/SET_LOADING'
export const SET_IS_EDIT_PREFERENCES_SUCCESS = 'accountSettingsPage/SET_IS_EDIT_PREFERENCES_SUCCESS'

export const CHANGE_TABS = 'accountSettingsPage/CHANGE_TABS'
